export const AnchorsDefaultClassesMock = ['anchors', 'test-class'];

export const AnchorsDefaultPropsMock = {
  className: 'test-class',
  anchors: [{ name: 'Overview', url: '/', queryString: '#Overview' }],
};

export const AnchorsChildrenMock = 'test content';
